import { Component, h } from '@stencil/core';

@Component({
  tag: 'utrecht-icon-lantaarnpaal-oud',
  styleUrl: "../../icon/generated.scss",
  shadow: true,
})
export class UtrechtIconLantaarnpaalOud {

  render() {
    return (
      <svg viewBox="0 0 36 36" xmlns="http://www.w3.org/2000/svg" fill="currentColor" height="1em" width="1em">
  <path d="M20.17 34v-8l-1.08-3V10h1.48l1.77-4.89h1.08v-1h-.78L18.6 1.5V0h-1.2v1.5l-4.04 2.61h-.78v1h1.08L15.43 10h1.48v13l-1.08 3v8H11.5v2h13v-2zM18.61 5h2.65l-.12.4-1.3 3.6h-1.23zm-2.37 4-1.3-3.6-.12-.4h2.65v4z"/>
</svg>

    );
  }
}
